import { observer } from "mobx-react-lite"
import Layout from "../components/layout/Layout";
import { Form, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useStore } from "../stores/root-store-context";
import { Input, Spin, message } from "antd";


const Login = observer(() => {
    const navigate = useNavigate();

    const [errorMessage, setError] = useState('');
    const [password, setPassword] = useState('string123*A');
    const [isLoading, setIsLoading] = useState(false);
    const { applicationStore } = useStore();
    async function handleSubmit(event: any) {
        event.preventDefault();
        setIsLoading(true);
        const formData = new FormData(event.currentTarget);
        const email = formData.get('email');
        await applicationStore.login(email as string, password as string);
        setIsLoading(false);
        if (!applicationStore.isAuthenticated) {
            message.open({
                type: 'error',
                content: 'Login or password incorect!',
                key: 'checkingTenaut'
            });
        } else {
            navigate(`/`);
        }
    }
    if (applicationStore.isAuthenticated) {
        return (
            <Layout headerStyle={1} footerStyle={2} >
                <section className="contact-section fix section-padding">
                    <div className="container">
                        <div className="contact-wrapper-2">
                            <div className="row g-4 align-items-center">
                                <div className="col-lg-12">
                                    <div className="col-lg-12">
                                        <div className="contact-content">
                                            <h2>Welcome</h2>
                                            <p>{applicationStore.user?.email}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </Layout>
        )
    }
    return (
        <Layout headerStyle={1} footerStyle={2} >
            <div>
                <section className="contact-section fix section-padding">
                    <div className="container">
                        <div className="contact-wrapper-2">
                            <div className="row g-4 align-items-center">
                                <div className="col-lg-12">
                                    <div className="col-lg-12">
                                        <div className="contact-content">
                                            <h2>Ready to Get Started?</h2>
                                            <p>
                                                Please fill in the required information.
                                            </p>
                                            <Spin spinning={isLoading}>
                                                <form onSubmit={handleSubmit} id="contact-form" className="contact-form-items">
                                                    <div className="row g-4">
                                                        <div className="col-lg-6 wow fadeInUp" data-wow-delay=".5s">
                                                            <div className="form-clt">
                                                                <span>Your Email*</span>
                                                                <input type="text" name="email" id="email" placeholder="Your Email" defaultValue={"seletsky@hotmail.com"} />
                                                                <div>Demo account: seletsky@hotmail.com</div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 wow fadeInUp" data-wow-delay=".3s">
                                                            <div className="form-clt">
                                                                <span>Your password*</span>
                                                                <Input id="password" placeholder="Password" type="password" defaultValue={"string123*A"} onChange={(e) => {
                                                                    setPassword(e.target.value);
                                                                }} />
                                                                <div>Demo account password: string123*A</div>

                                                            </div>
                                                        </div>
                                                        <div className="danger">{errorMessage}</div>
                                                        <div className="col-lg-12 wow fadeInUp" data-wow-delay=".9s">
                                                            <button type="submit" className="theme-btn" disabled={isLoading}>
                                                                Sign in <i className="fa-solid fa-arrow-right-long" />
                                                            </button>
                                                        </div>

                                                    </div>
                                                </form>
                                            </Spin>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </Layout>
    )
})
export default Login;